/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Default_Model_DescriptionInputs */



/**
* | output |
* | --- |
* | "The model a new agent runs on unless its creator picks another." |
*
* @param {Agent_Policy_Default_Model_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_default_model_description = /** @type {((inputs?: Agent_Policy_Default_Model_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Default_Model_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Modell, mit dem ein neuer Agent läuft, sofern die erstellende Person kein anderes wählt.")
	return /** @type {LocalizedString} */ ("The model a new agent runs on unless its creator picks another.")
});